import React from "react";
import { Container, Row, Col } from "reactstrap";

const NotFound = () => {
    return (
        <div style={styles.wrapper}>

            <div style={styles.light}></div>

            <div style={styles.particles}></div>
            <div style={styles.particles2}></div>

            {/* Content */}
            <Container className="position-relative text-center" style={{ zIndex: 2 }}>
                <Row className="justify-content-center">
                    <Col md="8" lg="6">
                        <h1 style={styles.code}>404</h1>
                        <h3 style={styles.title}>Form Not Found</h3>
                        <p style={styles.subtitle}>
                           This form is unavailable. It may have been removed, expired, or the link is invalid.
                        </p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

const styles = {
    wrapper: {
        position: "relative",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        background: `
      radial-gradient(circle at 15% 25%, rgba(255,255,255,0.10), transparent 40%),
      radial-gradient(circle at 85% 75%, rgba(255,255,255,0.06), transparent 45%),
      radial-gradient(circle at 50% 100%, rgba(0,114,206,0.15), transparent 60%),
      linear-gradient(135deg, #081c3a 0%, #1c3f75 50%, #0072ce 100%)
    `,
        color: "#fff",
    },

    // ✨ Particles
    particles: {
        position: "absolute",
        width: "200%",              // bigger for smooth movement
        height: "200%",
        top: "-50%",
        left: "-50%",
        backgroundImage:
            "radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px)",
        backgroundSize: "40px 40px",
        animation: "moveParticles 25s linear infinite",
        zIndex: 0,
    },

    particles2: {
        position: "absolute",
        width: "200%",
        height: "200%",
        top: "-50%",
        left: "-50%",
        backgroundImage:
            "radial-gradient(rgba(255,255,255,0.05) 1px, transparent 1px)",
        backgroundSize: "60px 60px",
        animation: "moveParticlesSlow 6s linear infinite",
        zIndex: 0,
    },

    // 💡 Light beam
    light: {
        position: "absolute",
        width: "300px",
        height: "300px",
        background:
            "radial-gradient(circle, rgba(255,255,255,0.15), transparent 70%)",
        top: "10%",
        left: "20%",
        filter: "blur(60px)",
        animation: "moveLight 12s ease-in-out infinite",
        zIndex: 0,
    },

    code: {
        fontSize: "100px",
        fontWeight: "700",
    },

    title: {
        fontSize: "26px",
        fontWeight: "600",
    },

    subtitle: {
        opacity: 0.85,
    },
};

export default NotFound;